import { Button, Stack, Typography } from "@mui/material";
import { IconCashBanknote } from "@tabler/icons-react";
import { formatPaymentType, formatDate, formatPrice } from "../helpers/format";
import { recurrenceList } from "../helpers/mock";

const PaymentModality = ({ data, onOpen }: any) => {
  const plan = data?.studentOnPlan[0];

  return (
    <Stack spacing={2}>
      <Typography
        variant="h4"
        fontSize={16}
        fontWeight={600}
        color="secondary.contrastText"
      >
        PLANO ATUAL
      </Typography>
      {!plan && (
        <Stack
          sx={{
            padding: 2,
            borderRadius: 2,
            backgroundColor: "secondary.main",
            gap: 2,
          }}
        >
          <Typography variant="h6" textAlign={"center"} fontWeight={700} mb={1}>
            Plano não cadastrado ou expirado.
          </Typography>

          <Button variant="contained" onClick={onOpen}>
            Cadastrar plano para aluno
          </Button>
        </Stack>
      )}

      {plan && (
        <Stack
          sx={{
            backgroundColor: "secondary.main",
            borderRadius: 2,
            padding: 2,
            gap: 2,
          }}
        >
          <Stack
            sx={{
              backgroundColor: "primary.main",
              padding: 2,
              borderRadius: 2,
            }}
          >
            <Typography variant="h6" fontWeight={700} mb={1}>
              {plan?.name}
            </Typography>{" "}
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography variant="body1">
                Recorrência:
                <strong>
                  {" "}
                  {recurrenceList.find((i) => i.id === plan.recurrence)?.name ||
                    ""}
                </strong>
              </Typography>{" "}
              <Typography variant="body1">
                Valor: <strong>{formatPrice(plan.value)} </strong>
              </Typography>{" "}
            </Stack>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography variant="body1">
                Incio do plano: <strong>{formatDate(plan.startDate)}</strong>
              </Typography>{" "}
              <Typography variant="body1">
                Fim do plano: <strong>{formatDate(plan.endDate)}</strong>
              </Typography>
            </Stack>
          </Stack>
          <Stack
            sx={{
              backgroundColor: "primary.main",
              padding: 2,
              borderRadius: 2,
            }}
            gap={1}
          >
            <Typography variant="h6" fontWeight={700}>
              Meio de pagamento
            </Typography>
            <Stack direction={"row"} gap={1}>
              <IconCashBanknote />
              <Typography variant="body1" fontWeight={600}>
                {formatPaymentType(plan.paymentType)}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default PaymentModality;
